export default __webpack_public_path__ + "static/media/CNo.46-4.1a5e78d9.jpg";